import http from '@/utils/network/http/axios'

/**
 * 获取企业信息
 * @param {*} params 
 * @returns 
 */
export function getCompanyInfo(params) {
    return http.post(`/company/getCompanyInfo`, params)
}

/** 
* 获取所属行业列表
* @param {*} params 
* @returns 
*/
export function getIndustryList(params) {
   return http.post(`/company/getIndustryList`, params)
}

/** 
* 获取所属行业列表
* @param {*} params 
* @returns 
*/
export function getSupervisionIndustryList(params) {
    return http.post(`/company/getSupervisionIndustryList`, params)
}

/** 
* 保存企业基本信息
* @param {*} params 
* @returns 
*/
export function saveCompanyInfo(params) {
   return http.post(`/company/saveBaseInfo`, params)
}

/** 
* 保存企业基本信息
* @param {*} params 
* @returns 
*/
export function saveManageInfo(params) {
    return http.post(`/company/saveManageInfo`, params)
}

/** 
* 获取企业下用户列表
* @param {*} params 
* @returns 
*/
export function getCompanyUserList(params) {
    return http.post(`/company/getCompanyUserList`, params)
}

/** 
* 保存用户
* @param {*} params 
* @returns 
*/
export function saveCompanyUser(params) {
    return http.post(`/company/saveCompanyUser`, params)
}

/** 
* 删除用户
* @param {*} params 
* @returns 
*/
export function deleteCompanyUser(params) {
    return http.post(`/company/deleteCompanyUser`, params)
}

/** 
* 根据身份证获取用户
* @param {*} params 
* @returns 
*/
export function _getUsers(params) {
    return http.post(`/user/_getUsers`, params)
}

/** 
* 检测是否上传验证头像
* @param {*} params 
* @returns 
*/
export function Userisfacecheck(params) {
    return http.post(`/user/userisfacecheck`, params)
}



/** 
* 获取证书列表
* @param {*} params 
* @returns 
*/
export function userCardList(params) {
    return http.post(`/company/userCardList`, params)
}

/** 
* 删除证书
* @param {*} params 
* @returns 
*/
export function userCardDel(params) {
    return http.post(`/company/userCardDel`, params)
}

/** 
* 保存证书
* @param {*} params 
* @returns 
*/
export function userCardAdd(params) {
    return http.post(`/company/userCardAdd`, params)
}

/** 
* 用户管理-获取用户的证书
* @param {*} params 
* @returns 
*/
export function studentCarddetailYpt(params) {
    return http.post(`/company/studentCarddetailYpt`, params)
}

/** 
* 添加企业
* @param {*} params 
* @returns 
*/
export function _doAccount_Qiye(params) {
    return http.post(`/company/_doAccount_Qiye`, params)
}

/** 
* 获取企业列表
* @param {*} params 
* @returns 
*/
export function getAccount_Qiye(params) {
    return http.post(`/company/getAccount_Qiye`, params)
}

/** 
* 获取培训机构列表（分页）
* @param {*} params 
* @returns 
*/
export function getAccount_pxjg(params) {
    return http.post(`/company/getAccount_pxjg`, params)
}

/** 
* 添加培训机构
* @param {*} params 
* @returns 
*/
export function _doAccount_pxjg(params) {
    return http.post(`/company/_doAccount_pxjg`, params)
}

/** 
* 获取企查查信息
* @param {*} params 
* @returns 
*/
export function getList_compbyqicha_r(params) {
    return http.post(`/company/getList_compbyqicha_r`, params)
}

/** 
* 获取预警证书列表
* @param {*} params 
* @returns 
*/
export function userCardWarn(params) {
    return http.post(`/company/userCardWarn`, params)
}

/** 
* 删除账号
* @param {*} params 
* @returns 
*/
export function deleteAccount(params) {
    return http.post(`/company/deleteAccount`, params)
}


/** 
* 获取企业、机构省列表
* @param {*} params 
* @returns 
*/
export function getAreasheng(params) {
    return http.post(`/company/getAreasheng`, params)
}

/** 
* 获取企业、机构市、、区、街道列表
* @param {*} params 
* @returns 
*/
export function getcity(params) {
    return http.post(`/company/getcity`, params)
}

/** 
* 获取高危工艺列表
* @param {*} params 
* @returns 
*/
export function getGwgyList(params) {
    return http.post(`/company/getGwgyList`, params)
}

/** 
* 获取政府账号列表
* @param {*} params 
* @returns 
*/
export function getAccount_zf(params) {
    return http.post(`/company/getAccount_zf`, params)
}

/** 
* 添加政府账号
* @param {*} params 
* @returns 
*/
export function _doAccount_zf(params) {
    return http.post(`/company/_doAccount_zf`, params)
}

/** 
* 启用账号（包含企业、机构。只有back有权限）
* @param {*} params 
* @returns 
*/
export function enableAccount(params) {
    return http.post(`/company/enableAccount`, params)
}

/** 
* 禁用账号（包含企业、机构。只有back有权限）
* @param {*} params 
* @returns 
*/
export function disableAccount(params) {
    return http.post(`/company/disableAccount`, params)
}

/**
* 获取需要生成证书的分类
* @param {*} params 
* @returns 
*/
export function getNeedCardCategory(params) {
    return http.post(`/company/getNeedCardCategory`, params)
}

/**
* 保存企业看视频所得证书
* @param {*} params 
* @returns 
*/
export function saveQyCateCard(params) {
    return http.post(`/company/saveQyCateCard`, params)
}

/**
* 获取需要授权的企业列表
* @param {*} params 
* @returns 
*/
export function getCompanyList(params) {
    return http.post(`/company/getCompanyList`, params)
}

/**
* 获取需要授权的企业和机构列表
* @param {*} params 
* @returns 
*/
export function getCompanyAndPxjgList(params) {
    return http.post(`/company/getCompanyAndPxjgList`, params)
}

/**
* 获取企业部门列表
* @param {*} params 
* @returns 
*/
export function getDepartWithLevel(params) {
    return http.post(`/company/getDepartWithLevel`, params)
}

/**
* 添加部门
* @param {*} params 
* @returns 
*/
export function addDepart(params) {
    return http.post(`/company/addDepart`, params)
}

/**
* 修改部门
* @param {*} params 
* @returns 
*/
export function updateDepart(params) {
    return http.post(`/company/updateDepart`, params)
}

/**
* 删除部门
* @param {*} params 
* @returns 
*/
export function deleteDepart(params) {
    return http.post(`/company/deleteDepart`, params)
}

/**
* 获取某一级的组织列表
* @param {*} params 
* @returns 
*/
export function getLevelDepartList(params) {
    return http.post(`/company/getLevelDepartList`, params)
}

/**
* 获取部门考核列表
* @param {*} params 
* @returns 
*/
export function getKhDepartList(params) {
    return http.post(`/company/getKhDepartList`, params)
}

/**
* 获取需要授权的培训机构列表
* @param {*} params 
* @returns 
*/
export function getPxjgAuthList(params) {
    return http.post(`/company/getPxjgAuthList`, params)
}

/**
* 获取三级安全教育
* @param {*} params 
* @returns 
*/
export function getSafetyCard(params) {
    return http.post(`/company/getSafetyCard`, params)
}

/**
* 保存三级安全教育
* @param {*} params 
* @returns 
*/
export function saveSafetyCard(params) {
    return http.post(`/company/saveSafetyCard`, params)
}

/**
* 获取学员的证明列表
* @param {*} params 
* @returns 
*/
export function getZhengmingList(params) {
    return http.post(`/company/getZhengmingList`, params)
}

/**
* 获取需要生成证明的分类
* @param {*} params 
* @returns 
*/
export function getNeedZhengmingCategory(params) {
    return http.post(`/company/getNeedZhengmingCategory`, params)
}

/**
* 保存企业看视频所得证明
* @param {*} params 
* @returns 
*/
export function saveZhengmingCard(params) {
    return http.post(`/company/saveZhengmingCard`, params)
}

/**
* 保存学员手册
* @param {*} params 
* @returns 
*/
export function studentManualAdd(params) {
    return http.post(`/company/studentManualAdd`, params)
}

/**
* 获取机构学员手册
* @param {*} params 
* @returns 
*/
export function getStudentManual(params) {
    return http.post(`/company/getStudentManual`, params)
}
export function getPbManual(params) {
    return http.post(`/company/api/getPbManual`, params)
}

/**
* 获取部门学员
* @param {*} params 
* @returns 
*/
export function getCompanyDeptUserList(params) {
    return http.post(`/company/getCompanyDeptUserList`, params)
}

/**
* 获取企业培训
* @param {*} params 
* @returns 
*/
export function getPlan(params) {
    return http.post(`/company/getPlan`, params)
}

/**
* 保存企业计划
* @param {*} params 
* @returns 
*/
export function savePlan(params) {
    return http.post(`/company/savePlan`, params)
}

/**
* 删除企业计划
* @param {*} params 
* @returns 
*/
export function deletePlan(params) {
    return http.post(`/company/deletePlan`, params)
}

/**
* 获取线下培训
* @param {*} params 
* @returns 
*/
export function getOfflineTrain(params) {
    return http.post(`/company/getOfflineTrain`, params)
}

/**
* 保存线下培训
* @param {*} params 
* @returns 
*/
export function saveOfflineTrain(params) {
    return http.post(`/company/saveOfflineTrain`, params)
}

/**
* 删除线下培训
* @param {*} params 
* @returns 
*/
export function deleteOfflineTrain(params) {
    return http.post(`/company/deleteOfflineTrain`, params)
}